module.exports = __webpack_public_path__ + "img/Franquicias.e77336bd.png";